import React from 'react';
import totiAsk from './icons/toti.png';
import './uiStyles.css';

export const Toti = () => {
    return (
        <>
        <img className='toti-ask' src={totiAsk} alt="toti-ask"/>
        </>
    )
}
export default Toti;
